import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Notifications", -1)
const _hoisted_2 = { class: "notifications-panel__alert-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__title" }, "Enable push notifications"),
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__description" }, "Stay up-to-date with important team activities.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Enable")
const _hoisted_5 = {
  key: 1,
  class: "notifications-panel__content"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__title" }, "Enable push notifications"),
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__description" }, "Stay up-to-date with important team activities.")
], -1)
const _hoisted_7 = { class: "notifications-panel__content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__title" }, "Enable notification emails"),
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__description" }, "Allow cadrelo to send email notifications.")
], -1)
const _hoisted_9 = { class: "notifications-panel__content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__title" }, "Enable product emails"),
  /*#__PURE__*/_createElementVNode("p", { class: "notifications-panel__description" }, "Stay up-to-date with latest cadrelo updates, we won’t spam you!")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppAlert = _resolveComponent("AppAlert")!
  const _component_AppSwitch = _resolveComponent("AppSwitch")!
  const _component_AppPanel = _resolveComponent("AppPanel")!
  const _component_NotificationsPanelSkeleton = _resolveComponent("NotificationsPanelSkeleton")!

  return (_ctx.notificationSettingsSynced)
    ? (_openBlock(), _createBlock(_component_AppPanel, {
        key: 0,
        class: "notifications-panel"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.showSoftPrompt)
            ? (_openBlock(), _createBlock(_component_AppAlert, {
                key: 0,
                icon: "info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_AppButton, { onClick: _ctx.requestNotificationPermission }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.showSoftPrompt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createVNode(_component_AppSwitch, {
                    id: "push-notifications",
                    modelValue: _ctx.enablePushNotifications,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enablePushNotifications) = $event)),
                    "onUserAction:toggle": _ctx.updateNotificationSettings
                  }, null, 8, ["modelValue", "onUserAction:toggle"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createVNode(_component_AppSwitch, {
                id: "notification-emails",
                modelValue: _ctx.enableNotificationEmails,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enableNotificationEmails) = $event)),
                "onUserAction:toggle": _ctx.updateNotificationSettings
              }, null, 8, ["modelValue", "onUserAction:toggle"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              _createVNode(_component_AppSwitch, {
                id: "product-emails",
                modelValue: _ctx.enableProductEmails,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enableProductEmails) = $event)),
                "onUserAction:toggle": _ctx.updateNotificationSettings
              }, null, 8, ["modelValue", "onUserAction:toggle"])
            ])
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_NotificationsPanelSkeleton, { key: 1 }))
}